
<ul class="navbar-nav ml-auto">

  <li class="nav-item d-flex"   *ngIf="logged && user && user.token">
  <a mdbWavesEffect type="button" class="nav-link waves-light text-theme">
    <mdb-icon fas icon="clock"></mdb-icon>
    <span class="clearfix d-inline-block">Tiempo</span>
  </a>
    <div class="md-form my-0 text-theme" style="width: 5rem; " >
      <mdb-select-2 class="text-center text-theme"
                    [(ngModel)]="interval" (ngModelChange)="updateInterval()"
                    dropdownClass="mdb-select-dropdown-colorful mdb-select-dropdown-primary">
        <mdb-select-option [class]="'text-theme'" [class.color]="'text-theme'" *ngFor="let option of timeOptions" [value]="option">
          <span>{{ option.name }}</span>
        </mdb-select-option>
      </mdb-select-2>
    </div>
  </li>

  <!-- <li class="nav-item"  *ngIf="logged && user && user.token">
    <a mdbWavesEffect type="button" class="nav-link waves-light text-theme" routerLink="/">
      <mdb-icon fas icon="briefcase"></mdb-icon>
      <span class="clearfix d-inline-block">Carteras</span>
    </a>
  </li> -->

  <li class="nav-item"  *ngIf="logged && user && user.token">
    <a class="nav-link position-relative text-theme">
      <mdb-icon fas icon="envelope" class="animated opacity-5" [class.tada]="notifying" [class.opacity-]="notifyStopped"></mdb-icon>
      <span class="clearfix d-inline-block d-lg-none">Notificaciones</span>
    </a>
  </li>

  <li class="nav-item dropdown" dropdown  *ngIf="logged && user && user.token">
    <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light text-theme">
      <mdb-icon fas icon="user"></mdb-icon>
      <span class="clearfix d-inline-block">{{user?.name}}</span><span class="caret"></span></a>
    <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu"
         style="transform: translateX(-100%) !important; left: 100%">
      <a class="dropdown-item waves-light" mdbWavesEffect routerLink="/cuenta/perfil">Perfil</a>

      <!-- <a class="dropdown-item waves-light" mdbWavesEffect >
        <mdb-icon fas icon="plus" class="text-theme"></mdb-icon>
          Importar
      </a> -->

      <div class="divider dropdown-divider"></div>
      <a class="dropdown-item waves-light" mdbWavesEffect href="javascript:void(0)" (click)="logout()">Salir</a>
    </div>
  </li>
  <li class="nav-item d-flex"  *ngIf="logged && user && user.token">
    <div class="switch my-auto primary-switch">
      <label class="my-0 pt-1">
        <input type="checkbox" [(ngModel)]="darkMode" (change)="changeDarkMode()">
        <span class="lever mb-1 mr-1 ml-2"></span>
        <mdb-icon fas icon="adjust" class="text-theme"></mdb-icon>
      </label>
    </div>
  </li>


</ul>
